module.exports = __webpack_public_path__ + "static/img/title_chevrolet@2x.9a0fcdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/title_chevrolet@2x.png
// module id = s/ld
// module chunks = 0